export const CloseIconBasic = `
<Button variant="icon-only" className="close" aria-label="Close">
  <i className="modus-icon material-icons" aria-hidden="true">close</i>
</Button>
  `
